import debug from 'debug';

const logger = debug('dashboards-client');

export default logger;
